var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.2002V13.2002M15 16.2002H21M11 13.2002H7C5.13623 13.2002 4.20435 13.2002 3.46927 13.5047C2.48915 13.9107 1.71046 14.6893 1.30448 15.6695C1 16.4045 1 17.3364 1 19.2002M14.5 1.49095C15.9659 2.08434 17 3.52151 17 5.2002C17 6.87888 15.9659 8.31605 14.5 8.90944M12.5 5.2002C12.5 7.40933 10.7091 9.2002 8.5 9.2002C6.29086 9.2002 4.5 7.40933 4.5 5.2002C4.5 2.99106 6.29086 1.2002 8.5 1.2002C10.7091 1.2002 12.5 2.99106 12.5 5.2002Z",
    stroke: "#4657F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.febb9c4897fa6aa5087430cbec1ea02a.svg";
export { ForwardRef as ReactComponent };